import _ from 'lodash';
import { QuestionnaireScreenDefaultFieldName, } from '../../types/carrierQuestionnaire/screen';
import QuestionnaireVisitor from '../QuestionnaireVisitor';
export class QuestionnaireScreenExtenderVisitor extends QuestionnaireVisitor {
    screenConfig;
    constructor(screenConfig) {
        super();
        this.screenConfig = screenConfig;
    }
    visitQuestionnaire(questionnaire) {
        const clonedQuestionnaire = _.cloneDeep(questionnaire);
        super.visitQuestionnaire(clonedQuestionnaire);
        return { questionnaire: clonedQuestionnaire, output: undefined };
    }
    visitField(field) {
        const fieldConfig = this.screenConfig?.[field.type] || this.screenConfig[QuestionnaireScreenDefaultFieldName];
        if (fieldConfig?.optional !== undefined) {
            field.optional = fieldConfig.optional ? true : undefined;
        }
        if (fieldConfig?.validationType !== undefined) {
            field.validation.type = fieldConfig.validationType;
        }
        if (fieldConfig?.skipValidityConditions !== undefined && fieldConfig?.skipValidityConditions) {
            field.validIf = [];
        }
    }
}
export function extendQuestionnaireWithScreen(questionnaire, screenConfig) {
    const visitor = new QuestionnaireScreenExtenderVisitor(screenConfig);
    const { questionnaire: extendedQuestionnaire } = visitor.visitQuestionnaire(questionnaire);
    return extendedQuestionnaire;
}
